'use strict';

function FetchHeaders(fetchHeaders) {
  this.get = fetchHeaders.get.bind(fetchHeaders);
  this.has = fetchHeaders.has.bind(fetchHeaders);
}

module.exports = FetchHeaders;
